<mat-form-field>
  <mat-label>{{ ctx.placeholder }}</mat-label>
  <input matInput type="password" [placeholder]="ctx.placeholder" [formControl]="ctx.control" />
  <mat-hint *ngIf="ctx.hint">i.e. {{ ctx.hint }}</mat-hint>
</mat-form-field>
